import React from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {
    TextField,
    Grid
} from '@material-ui/core/';
import config from '../../Config/config';

export const ReviewAndSend = ({ values, errors, onChange }) => {
    const withSeparator = (theNumber, decimals) => theNumber.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/u, ',');
    const reach = config.PRICE_CALCULATIONS.reach(values);
    const avgPricePost = config.PRICE_CALCULATIONS.avgPricePost(values);
    const avgPriceVideo = config.PRICE_CALCULATIONS.avgPriceVideo(values);

    const numberOfPeople = config.PRICE_CALCULATIONS.numberOfPeople(values);

    return (
        <div>
            <DialogContent>
                <Grid container >
                    <Typography variant="h6">
                        Review and submit
                    </Typography>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" style={{ color: 'rgba(0,0,0,0.57)', padding: '8px' }}>
                            Your campaign will reach approximately {withSeparator(reach, 0)} people on social media.
                        </Typography>
                    </Grid>

                    {values.promoteByPost && <Grid item xs={12}>
                        <Typography variant="subtitle1" style={{ color: 'rgba(0,0,0,0.57)', padding: '8px' }}>
                            The average price per post is £{withSeparator(avgPricePost, 2)}.
                        </Typography>
                    </Grid>}

                    {values.promoteByStory && (<Grid item xs={12}>
                        <Typography variant="subtitle1" style={{ color: 'rgba(0,0,0,0.57)', padding: '8px' }}>
                            The average price per video is £{withSeparator(avgPriceVideo, 2)}.
                    </Typography>
                    </Grid>)}

                    <Grid item xs={12}>
                        <Typography variant="subtitle1" style={{ color: 'rgba(0,0,0,0.57)', padding: '8px' }}>
                            You will have approximately {withSeparator(numberOfPeople, 0)} people posting about your brand.
                        </Typography>
                    </Grid>
                </Grid>

                {/* <div className="brief-wrapper">
                    <Typography variant="subtitle1" style={{ color: 'rgba(0,0,0,0.57)', padding: '8px' }}>
                        This is how your brief will look like to your brand fans:
                        </Typography>
                    <div className="brief-container">
                        <div style={{ color: 'rgba(0,0,0,0.57)', fontSize: '40px', fontWeight: '600', margin: 'auto' }}>TBU</div>
                    </div>
                </div> */}
            </DialogContent>
        </div>
    )
}